module.exports = __webpack_public_path__ + "static/beacon-ff7b4d1185200bafff31664bffbfc70c.mp4";